import { render, staticRenderFns } from "./fullsize-gallery.vue?vue&type=template&id=d3ad591c"
import script from "./fullsize-gallery.vue?vue&type=script&lang=js"
export * from "./fullsize-gallery.vue?vue&type=script&lang=js"
import style0 from "./fullsize-gallery.vue?vue&type=style&index=0&id=d3ad591c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCarousel: require('/var/www/tubber-new/components/global/v/carousel.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,BaseModal: require('/var/www/tubber-new/components/global/base-modal.vue').default})
